<div id="categories-container">
    <div *ngFor="let category of categoryArr">
        <p>{{category}}</p>
    </div>
</div>
